import React, { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { RequestQuote } from "@mui/icons-material";
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { SETTLEMENTS_ENDPOINT, SETTLEMENT_STATUS_TO_COLOR } from '../../../../consts';
import styles from './clientSettlementsDetail.module.css';
import { useHasPermission } from '../../../../contexts/auth';
import { getMonthNames, formatDateTime } from '../../../../utils';

export const ClientSettlementsDetail = () => {
  const { t } = useTranslation();
  const { id, period } = useParams();
  const canViewSettlements = useHasPermission("settlement.view_settlement");
  const monthNames = getMonthNames(t);

  const columns: GridColDef[] = useMemo(() => [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "contract_number",
      headerName: t("Contract Number"),
      sortable: false,
    },
    {
      field: "equipment_name",
      headerName: t("Equipment Name"),
      sortable: false,
    },
    {
      field: "status",
      headerName: t("Status"),
      sortable: false,
      renderCell: (params) => {
        const color = SETTLEMENT_STATUS_TO_COLOR[params.row.status] || "default";
        return (
          <Chip
            label={params.row.status_display}
            color={color}
            size="small"
          />
        );
      },
    },
    {
      field: "total_display",
      headerName: t("Net Total"),
      sortable: false,
      type: "number",
    },
    {
      field: "sale_date",
      headerName: t("Sale date"),
    },
    {
      field: "confirmed_date",
      headerName: t("Confirmed at"),
      valueFormatter: (value) => formatDateTime(value),
    },
  ], [t]);

  if (!canViewSettlements) {
    return null;
  }

  const [year, month] = period ? period.split('-') : [null, null];
  const monthName = month ? monthNames[parseInt(month)] : '';
  const title = `${t('Settlements for')} ${monthName} ${year}`;
  const settlementsUrl = `${SETTLEMENTS_ENDPOINT}monthly-detail/?client=${id}&year=${year}&month=${month}`;

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<RequestQuote />}
        title={title}
        url={settlementsUrl}
        gridSettingsKey="CLIENT_SETTLEMENTS_DETAIL"
        columns={columns}
      />
    </Box>
  );
};
